import React from 'react'

import './PrivateKey.css'
import QbHeading from '../shared/QbHeading/QbHeading'
import QbDisplay from '../shared/QbDisplay/QbDisplay'
import QbButton from '../shared/QbButton/QbButton'
import QbText from '../shared/QbText/QbText'
import WebMenuHolder from '../shared/WebMenu/WebMenuHolder'

const PrivateKey = ({
  t,
  privateKey,
  onClose,
}) => (
  <div className="main-content-container">
    <WebMenuHolder title={t('wallet.private-key-title')} />
    <div className="main-content-body">
      <QbHeading title={t('wallet.private-key.headline')} text={t('wallet.private-key.message')}/>
      <QbText style={PRIVATE_KEY_STYLES.NOTE}>{t('wallet.private-key.note')}</QbText>
      <div className="title-input-button">
        <QbDisplay
          value={privateKey}
          contentStyle={PRIVATE_KEY_STYLES.DISPLAY_CONTENT}
        />
        <div className="main-content-footer private-key-button">
          <QbButton name="Close" onClick={() => onClose()} style={PRIVATE_KEY_STYLES.BUTTON} />
        </div>
      </div>
    </div>
  </div>
)

export default PrivateKey

const PRIVATE_KEY_STYLES = {
  DISPLAY_CONTENT: {
    height: 'auto',
    fontWeight: 600
  },
  NOTE: {
    fontWeight: 600,
    textAlign: 'left'
  }
}



// WEBPACK FOOTER //
// ./src/components/PrivateKey/PrivateKey.js